import React, { Component } from "react";
import Grid from "../../Utils/Grid";
import { standardActions } from "../../Utils/Grid/StandardActions";
import { Link } from "react-router-dom";

class Listar extends Component {
    state = {
        page: 1,
        search: "",
        BreakLine: {
            whiteSpace: "normal",
        },
        params: {
            activo: true,
        },
    };

    componentDidMount() {
        this.props.listar(this.state.page, this.state.params);
    }

    onPageChange = (page) => {
        this.props.listar(page, this.state.params);
        this.setState({ page });
    };

    render() {
        const { data, loader, eliminar } = this.props;
        return (
            <React.Fragment>
                <div className="flex row mt-2">
                <div className="col-12">
                        <h2 className="title--blue">LISTA DE PUESTOS</h2>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-12 col-md-6" style={{display: 'flex', justifyContent: 'flex-start'}}>
                        <input
                            placeholder="Buscar..."
                            type="text"
                            className="form-control mt-4 input--style"
                            value={this.state.search}
                            onKeyPress={(key) => {
                                if (key.key == "Enter") {
                                    const { page, search } = this.state;
                                    this.props.listar(page, { search });
                                }
                            }}
                            onChange={(tx) => {
                                this.setState({ search: tx.target.value });
                            }}
                            style={{
                                color: "black",
                                fontSize: 15,
                                width: "55%",
                                float: "right",
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-6" style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Link to="/puestos/crear"
                            className="btn btn-primary mt-4"
                            style={{ fontSize: 15, borderRadius: "5px" }}>
                            Nuevo puesto
                        </Link>
                    </div>
                </div>
                <Grid
                    data={data}
                    loading={loader}
                    page={this.state.page}
                    onPageChange={this.onPageChange}
                >
                    <TableHeaderColumn dataField="nombre" dataSort >
                        Nombre
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="departamento_label" dataSort >
                        Departamento
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="id"
                        dataSort
                        isKey
                        dataFormat={(cell, row) => {
                            let props = {};
                            props.editar = "puestos";
                            props.eliminar = eliminar;
                            const actions = standardActions({ ...props });
                            return actions(cell, row);
                        }}
                    >
                        Acciones
                    </TableHeaderColumn>
                </Grid>
            </React.Fragment>
        );
    }
}

export default Listar;
